<template>
  <div>Consultation view</div>
</template>

<script setup lang="ts"></script>
